import { DateTime } from 'luxon';

export function convertClientDateTimeToServerISO(dt: DateTime) {
  return dt.toUTC().toISO();
}
